module.exports = __webpack_public_path__ + "static/henry_icon-b07b7cf66baa516637cb00daca7414b8.png";